// extracted by mini-css-extract-plugin
export var cartContainer = "_ow-4";
export var gray = "_ow-1";
export var itemContainer = "_ow-2";
export var itemDetails = "_ow-3";
export var strong = "_ow-0";